import AppDispatcher from '../dispatcher/AppDispatcher';
import AccountReorderParser from '../parsers/AccountReorderParser';
import AccountsPreferenceConstants from '../constants/AccountsPreferenceConstants';
import UserManagementStore from '../stores/UserManagementStore';
import FavouritesConstants from '../constants/FavouritesConstants';
import { buildFavouriteRequestFromList } from '../utils/FavouritesUtils';
import envConfig from '../../static/config';
import FavouritesStore from '../stores/AccountsStore/FavouritesStore';

class AccountReorderActions {
  getAccounts() {
    AppDispatcher.handleViewAction({
      actionType: AccountsPreferenceConstants.REQUEST_ACCOUNT_REORDER,
    });
  }
  setBackPageReference(urlString) {
    AppDispatcher.handleViewAction({
      actionType: AccountsPreferenceConstants.REORDER_BACKPAGE_REFERENCE,
      urlString,
    });
  }

  setAccountOrderChanges(request) {
    if (
      UserManagementStore.isSMEUser() &&
      FavouritesStore.isLargeCustomer() &&
      envConfig.isLcvEnabled
    ) {
      AppDispatcher.handleViewAction({
        actionType: FavouritesConstants.REORDER_FAVOURITE_ACCOUNTS,
        data: buildFavouriteRequestFromList(request),
      });
    } else {
      AppDispatcher.handleViewAction({
        actionType: AccountsPreferenceConstants.SET_ACCOUNT_REORDER,
        data: AccountReorderParser.getOrderedChangedAccounts(request),
      });
    }
  }

  nextReorderBatchCall(response) {
    AppDispatcher.handleViewAction({
      actionType: AccountsPreferenceConstants.ACCOUNT_REORDER_BATCH_CALL,
      data: response, // this is success response for prev one
    });
  }
}

export default new AccountReorderActions();
